import { defineAsyncComponent } from 'vue';

export default {
	description: "Движения медикаментов",
	access: {
		read: true,
		create: true,
		update: true,
		delete: true
	},
	forms: {
		edit: {
			panel: {
				width: '60%'
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		},
		list: {
			config: {},
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		},
		select: {
			panel: {
				width: '90%',
				height: '700px'
			},
			config: {
				fields: {
					medicament_id: {
					},
					warehouse_from_id: {
					},
					warehouse_to_id: {
					},
					quantity: {
					},
					unit_id: {
					},
					operation_type: {
					},
					reason: {
					},
					document_number: {
					},
					document_date: {
					},
					patient_id: {
					},
					employee_id: {
					}
				}
			}
		}
	}
} 